import { useDrawdownRepaymentSchedule } from '@api/lendingAPI/lapiHooks';
import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { ErrorMessage } from '@iwoca/orion-ui';
import { Skeleton } from '@ui';
import { FormattedMessage } from 'react-intl';

import { isSelectedAmountValid } from './isSelectedAmountValid';
import { Rate } from '../../../../../ui/rate';

export const InterestRate = ({
    drawdownAmount,
    selectedOffer
}: {
    drawdownAmount: number;
    selectedOffer: TFormalOffer;
}) => {
    const { data, isLoading, isError } = useDrawdownRepaymentSchedule({
        offerId: selectedOffer.offer_id!,
        drawdownAmount,
        enabled: isSelectedAmountValid(drawdownAmount, selectedOffer)
    });

    if (isLoading) return <Skeleton className="h-[20px] w-[50px]" />;
    if (isError)
        return (
            <ErrorMessage>
                <ErrorMessage.Icon />
                <ErrorMessage.Text>
                    <FormattedMessage
                        id="_.topup_choice.generic_error_message"
                        defaultMessage="Oops, it looks like something went wrong"
                    />
                </ErrorMessage.Text>
            </ErrorMessage>
        );

    const blendedRateDetails = data.summary.blended_rate_details;

    if (blendedRateDetails) {
        return (
            <Rate value={blendedRateDetails.rate_on_post_funding_principal} />
        );
    }

    return <Rate value={selectedOffer.interest_rates![0].rate!} />;
};
